import Vue from 'vue';
import Vuex from 'vuex';
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    displayName: '',
    cartItems: [],
    snackbars: [],
  },
  getters: {
    user: (state) => state.user,
    cartItems: (state) => state.cartItems,
  },
  mutations: {
    updateUser: (state, payload) => {
      state.user = payload;
    },
    setUser: (state, payload) => {
      if (payload == null) {
        state.user = null;
      } else {
        state.user = payload.user.uid;
        state.displayName = payload.user.displayName;
      }
      // state.user = Firebase.auth().currentUser;
    },
    SET_SNACKBAR(state, snackbar) {
      state.snackbars = state.snackbars.concat(snackbar);
    },
    removeUser: (state) => {
      state.user = null;
    },
    setCartItem: (state, payload) => {
      state.cartItems = payload;
    },
    addCartItem: (state, payload) => {
      const index = state.cartItems
        .map(function(x) {
          return x.id;
        })
        .indexOf(payload.id);
      if (index === -1) {
        state.cartItems.push(payload);
        state.snackbars = state.snackbars.concat({
          showing: true,
          color: 'success',
          text: 'Added this item to your cart.',
        });
      } else {
        state.snackbars = state.snackbars.concat({
          showing: true,
          color: 'error',
          text: 'This item is already in your cart.',
        });
      }
    },
    removeCartItem: (state, payload) => {
      const index = state.cartItems
        .map(function(x) {
          return x.id;
        })
        .indexOf(payload.id);
      if (index > -1) {
        state.cartItems.splice(index, 1);
      }
    },
    removeEntireCart: (state) => {
      state.cartItems = [];
    },
  },
  actions: {
    addCartItem({ commit }, payload) {
      commit('addCartItem', payload);
    },
    removeCartItem({ commit }, payload) {
      commit('removeCartItem', payload);
    },
    removeEntireCart({ commit }) {
      commit('removeEntireCart');
    },
    setSnackbar({ commit }, snackbar) {
      snackbar.showing = true;
      snackbar.color = snackbar.color || 'success';
      commit('SET_SNACKBAR', snackbar);
    },
    signUpAction({ commit }, payload) {
      firebase
        .auth()
        .createUserWithEmailAndPassword(payload.email, payload.password)
        .then((response) => {
          return response.user
            .updateProfile({
              displayName: payload.displayName,
              photoURL: payload.photoURL,
            })
            .then(() => {
              const snackbar = {};
              snackbar.showing = true;
              snackbar.color = 'success';
              snackbar.text = 'You have successfully signed up.';
              commit('SET_SNACKBAR', snackbar);
              commit('setUser', response);
            });
        })
        .catch((error) => {
          const snackbar = {};
          snackbar.showing = true;
          snackbar.color = 'error';
          snackbar.text = error.message;
          commit('SET_SNACKBAR', snackbar);
        });
    },

    signInAction({ commit }, payload) {
      firebase
        .auth()
        .signInWithEmailAndPassword(payload.email, payload.password)
        .then((response) => {
          console.log(response);
          const snackbar = {};
          snackbar.showing = true;
          snackbar.color = 'success';
          snackbar.text = 'You have successfully sign in.';
          commit('SET_SNACKBAR', snackbar);
          commit('setUser', response);
        })
        .catch((error) => {
          console.log(error);
          const snackbar = {};
          snackbar.showing = true;
          snackbar.color = 'error';
          snackbar.text = error.message;
          commit('SET_SNACKBAR', snackbar);
        });
    },

    signOutAction({ commit }) {
      firebase
        .auth()
        .signOut()
        .then((response) => {
          console.log(response);
          const snackbar = {};
          snackbar.showing = true;
          snackbar.color = 'success';
          snackbar.text = 'You have successfully signed out.';
          commit('SET_SNACKBAR', snackbar);
          commit('setUser', null);
        })
        .catch((error) => {
          console.log(error);
          const snackbar = {};
          snackbar.showing = true;
          snackbar.color = 'error';
          snackbar.text = error.message;
          commit('SET_SNACKBAR', snackbar);
        });
    },
  },
  modules: {},
});
